var $=jQuery;
jQuery(document).ready(function ($) {
  /*** CUSTOM INFO */
  var $popup = $('#infoPopup');
var $close = $('.info-close');


$('#infoToggle').on('click', function() {
  $popup.fadeIn(200).css('display', 'flex');
});


$close.on('click', function() {
  $popup.fadeOut(200);
});


$popup.on('click', function(e) {
  if ($(e.target).is('#infoPopup')) {
    $popup.fadeOut(200);
  }
});

    /*** CUSTOM INFO */
    $('#main-cart-footer #Cart-note').hide();
      $(document).ready(function() {
      var $checkbox = $('#abstellgenehmigung_checkbox');
      var $selectDiv = $('.cart__abstellgenehmigung_select');
      var $select = $('#abstellgenehmigung_location');
      var $cartNote = $('#Cart-note');
         $checkbox.prop('checked', true);
        $cartNote.show(); 
      $checkbox.on('change', function() {
        if ($(this).is(':checked')) {
           $('#main-cart-footer #Cart-note').show();
        } else {
           $('#main-cart-footer #Cart-note').hide();
        }
      });

    });


  //click popup refund
  $('.logo-poup').on('click', function () {
    $('#poup-refund').addClass('active');
    $('body').css('overflow','hidden');
  });
  $('.close-rf').on('click', function () {
    $('#poup-refund').removeClass('active');
    $('body').css('overflow','visible');
  });
  
   //click popup refund
    $('.select__select').on('change', function() {
        var $select = $(this);
        var selectedOption = $select.find(':selected');
        var selectedValue = selectedOption.val();
        var formattedPrice = selectedOption.data('price');
    
        var $productItem = $select.closest('.pdp_detail');
    
        $productItem.find('.pdp_price').html(formattedPrice);
    
        $productItem.find('.product-variant-id').val(selectedValue);
    });
  
  //   if ($(window).width() < 850) {
		// $('.about_us_custom .brand-info').flickity({
		// 	imagesLoaded: true, 
  //           groupCells: true, 
  //           dragThreshold : 5, 
  //           cellAlign: 'left',
  //           wrapAround: true,
  //           prevNextButtons: true,
  //           percentPosition: true,
  //           pageDots: false, 
  //           rightToLeft: false, 
  //           autoPlay : true
		// });
  //   }

    var urlParams = new URLSearchParams(window.location.search);
    var tab = window.location.hash.substring(1);
    
    if (tab) {
      $("#" + tab.toLowerCase()).addClass("active");

         var $activeTab = $("#" + tab.toLowerCase());

      if ($activeTab.length) {
        $activeTab.addClass("active");
        $activeTab.trigger("click");
      }
      
    }
  $('#allgemeine-fragen .acc-container > .acc:nth-child(1) .acc-head').addClass('active');
  $('#allgemeine-fragen .acc-container > .acc:nth-child(1) .acc-content').css('display','block');
  $('.js .menu-drawer__menu li:nth-child(1) .menu-drawer__menu-item').addClass('active');
  $('.menu-drawer .menu-drawer__menu-item').on('click', function () {
    $('.menu-drawer .menu-drawer__menu-item').removeClass('active');
    $(this).addClass('active');
  });
  // Show the popup when the button is clicked
  // $('ul#zum_wunschdatum_liefern li span ').on('click', function () {
  //   $('#popup').fadeIn(); // Show popup with fade-in effect
  //   $('html').addClass('active');
  // });

  // // Hide the popup when the close button is clicked
  // $('#closeBtn').on('click', function () {
  //   $('#popup').fadeOut(); // Hide popup with fade-out effect
  //   $('html').removeClass('active');
  // });

  // // Hide the popup when clicking outside the popup content
  // $(window).on('click', function (e) {
  //   if ($(e.target).is('#popup')) {
  //     $('#popup').fadeOut(); // Hide popup
  //   }
  // });

  // Handle the confirm button
  // $('#confirmBtn').on('click', function () {
  //   const selectedDate = $('.flatpickr-day.selected').attr('aria-label');
  //   if (selectedDate) { 
  //     $("#datum").val(selectedDate);
  //     $('#popup').fadeOut(); 
  //     $('.product-option dt').each(function() {
  //       if ($(this).text().trim() === 'Datum:') {
  //         $(this).addClass('datum-icon');  // Add a custom class
  //       }
  //     });
      
  //   }
    
   
  // });
  
  //footer
  $('.footer-block.has-dropdown .footer-block__heading').click(function (e) { 
        e.preventDefault();
        $(this).toggleClass('active');
    });
  //slider mini cart
  
  var swiper = new Swiper('.slider-upsell', {
    slidesPerView: 1,
    spaceBetween:10,
    loop: true,
    centeredSlides: true,
    autoplay: {
      delay: 50000,
      disableOnInteraction: false,
    },
     navigation: {
      nextEl: '.upsell_products .swiper-button-next',
      prevEl: '.upsell_products .swiper-button-prev',
    }
  });
  //slider mini cart
   $(".wrap-topbar").flickity({
      pageDots: false,
      freeScroll: false,
      wrapAround: true,
      prevNextButtons: false,
      autoPlay: 5000,
      groupCells: false,
      cellAlign: 'center',
      
  });
  //accordition
  $(document).on('click','.acctab_title', function(e){
      if($(window).width() >= 768){
          $('.acctab_title').removeClass('active-accor');
          $(this).addClass('active-accor');
          $('.acc_tab-inner .acc-tab-content .tabs-content').removeClass('activemain-tab').hide();
          $($(this).attr('data-act-title')).addClass('activemain-tab').show();
      }else{
      $('.acctab_title').removeClass('active-accor');
          $(this).addClass('active-accor');
          $('.acc_tab-inner .acc-tab-content .tabs-content').removeClass('activemain-tab').hide();
          $($(this).attr('data-act-title')).addClass('activemain-tab').show();
          // $('.acc_tab-inner .acc-tab-content .tabs-content').removeClass('activemain-tab').hide();
          $('.acc_tab-inner .acc-tab-content').addClass('tab-content-show').show();
          $($(this).attr('data-act-title')).addClass('activemain-tab').show();
      }
  });
  $(document).on('click','.acc_tab-inner .acc-tab-content .back__arrow', function(e){
      $('.acc_tab-inner .acc-tab-content').removeClass('tab-content-show').show();
  });
  // $('.acc-container .acc:nth-child(1) .acc-head').addClass('active');
  // $('.acc-container .acc:nth-child(1) .acc-content').slideDown();
  $('.acc-head').on('click', function() {
      if($(this).hasClass('active')) {
          $(this).siblings('.acc-content').slideUp();
          $(this).removeClass('active');
      }
      else {
          $('.acc-content').slideUp();
          $('.acc-head').removeClass('active');
          $(this).siblings('.acc-content').slideToggle();
          $(this).toggleClass('active');
      }
  });
  //end accordition
  //login and register
  // Show password
  const togglePassword = document.querySelector('.togglePassword');
  const password = document.querySelector('.CustomerPassword');
  if(togglePassword && password)
  {
    togglePassword.addEventListener('click', function (e) {
      const type = password.getAttribute('type') === 'password' ? 'text' : 'password';
      password.setAttribute('type', type);
      this.classList.toggle('show-password');
    });
  }
  initEventListeners();
  // Show password
  const togglePassword2 = document.querySelector('#confirm-password');
  const password2 = document.querySelector('#ForgotPassword');
  if(togglePassword2 && password2) {
    togglePassword2.addEventListener('click', function (e) {
      const type = password2.getAttribute('type') === 'password' ? 'text' : 'password';
      password2.setAttribute('type', type);
      this.classList.toggle('show-password');
    });
  }
  // custom reset pass //
  function checkUrlHash() {
    var hash = window.location.hash;

    // Allow deep linking to recover password form
    if (hash === '#recover') {
      toggleRecoverPasswordForm();
    }
  }
  function toggleRecoverPasswordForm() {
    var passwordForm = document.getElementById('RecoverPasswordForm').classList.toggle('hide');
    var loginForm = document.getElementById('CustomerLoginForm').classList.toggle('hide');
  }

  function initEventListeners() {
      // Show reset password form
      var recoverForm = document.getElementById('RecoverPassword');
      if (recoverForm) {
        recoverForm.addEventListener('click', function(evt) {
          evt.preventDefault();
          toggleRecoverPasswordForm();
        });
      }
  
      // Hide reset password form
      var hideRecoverPassword = document.getElementById('HideRecoverPasswordLink');
      if (hideRecoverPassword) {
        hideRecoverPassword.addEventListener('click', function(evt) {
          evt.preventDefault();
          toggleRecoverPasswordForm();
        });
      }
    }
  //login and register
  // blog sorting
  $('.filter-blog-icon,.dropdown-title').click(function (e) { 
        e.preventDefault();
        $(this).toggleClass('active');
  });
  $("#sorting-dropdown").change(function() {
      var selectedOption = $(this).val();
      sortBlogPosts(selectedOption);
  });
  $('.blog-search').on('input', function(){
    var get_input = $(this).val().toLowerCase(); 
    $('.blog-articles__article').each(function(){
        var articleHeading = $(this).find('.card__heading a').text().toLowerCase();
        if(articleHeading.includes(get_input)){
            $(this).show();
        }
        else{
            $(this).hide();
        }
    });
  });
  function sortBlogPosts(option) {
    var postsContainer = $(".blog-articles");
    var posts = postsContainer.children(".cust_sort_blog");
  
    switch (option) {
      case "title-ascending":
        posts.sort(function(a, b) {
          return $(a).find(".blog-post-title").text().localeCompare($(b).find(".blog-post-title").text());
        });
        break;
      case "title-descending":
        posts.sort(function(a, b) {
          return $(b).find(".blog-post-title").text().localeCompare($(a).find(".blog-post-title").text());
        });
        break;
      case "created-ascending":
        posts.sort(function(a, b) {
          var dateA = new Date($(a).find(".blog-post-date").text());
          var dateB = new Date($(b).find(".blog-post-date").text());
          return dateA - dateB;
        });
        break;
      case "created-descending":
        posts.sort(function(a, b) {
          var dateA = new Date($(a).find(".blog-post-date").text());
          var dateB = new Date($(b).find(".blog-post-date").text());
          return dateB - dateA;
        });
        break;
      default:
        // No sorting, maintain original order
        break;
    }
  
    postsContainer.empty().append(posts);
  }
  //load more product
   document.addEventListener('DOMContentLoaded', function() {
    const loadMoreButton = document.querySelector('[data-pagination-btn]');
    const productGrid = document.getElementById('product-grid');
    
    if (loadMoreButton) {
        loadMoreButton.addEventListener('click', function(e) {
            e.preventDefault();
            const nextUrl = loadMoreButton.getAttribute('href');
            
            loadMoreButton.textContent = "Laden...";
            loadMoreButton.setAttribute('disabled', 'true');
            
            fetch(nextUrl)
                .then(response => response.text())
                .then(data => {
                    const tempDiv = document.createElement('div');
                    tempDiv.innerHTML = data;
                    
                    const newProducts = tempDiv.querySelector('#product-grid').innerHTML;
                    
                    productGrid.innerHTML += newProducts;
                    
                    // var sliderProducts = document.querySelectorAll('.has-slider-wrapper');

                    // sliderProducts.forEach(function(slider) {
                    //     new Flickity(slider, {
                    //         pageDots: false,
                    //         freeScroll: false,
                    //         wrapAround: true,
                    //         prevNextButtons: true,
                    //         autoPlay: false,
                    //         groupCells: false,
                    //         cellAlign: 'center',
                    //     });
                    // });
                    
                    const newButton = tempDiv.querySelector('[data-pagination-btn]');
                    if (newButton) {
                        loadMoreButton.setAttribute('href', newButton.getAttribute('href'));
                        loadMoreButton.textContent = "MEHR ANZEIGEN";
                        loadMoreButton.removeAttribute('disabled');
                    } else {
                        loadMoreButton.textContent = "Keine Produkte mehr";
                    }
                })
                .catch(error => {
                    console.error('Error loading more products:', error);
                    loadMoreButton.textContent = "Try again";
                    loadMoreButton.removeAttribute('disabled');
                });
        });
    }
  });
});


class PriceRange1 extends HTMLElement {
  connectedCallback() {
    this.rangeLowerBound = this.querySelector(".price-range__range-group input:first-child");
    this.rangeHigherBound = this.querySelector(".price-range__range-group input:last-child");
    this.textInputLowerBound = this.querySelector(".price-range__input:first-child input");
    this.textInputHigherBound = this.querySelector(".price-range__input:last-child input");

    // Event listeners for text input focus and change
    this.textInputLowerBound.addEventListener("focus", () => this.textInputLowerBound.select());
    this.textInputHigherBound.addEventListener("focus", () => this.textInputHigherBound.select());

    this.textInputLowerBound.addEventListener("change", (event) => {
      const newValue = Math.max(Math.min(parseInt(event.target.value), parseInt(this.textInputHigherBound.value || event.target.max) - 1), event.target.min);
      event.target.value = newValue;
      this.rangeLowerBound.value = newValue;
      this.updateRangeStyles();
    });

    this.textInputHigherBound.addEventListener("change", (event) => {
      const newValue = Math.min(Math.max(parseInt(event.target.value), parseInt(this.textInputLowerBound.value || event.target.min) + 1), event.target.max);
      event.target.value = newValue;
      this.rangeHigherBound.value = newValue;
      this.updateRangeStyles();
    });

    // Event listeners for range slider change and input
    this.rangeLowerBound.addEventListener("change", (event) => {
      this.textInputLowerBound.value = event.target.value;
      this.textInputLowerBound.dispatchEvent(new Event("change", { bubbles: true }));
    });

    this.rangeHigherBound.addEventListener("change", (event) => {
      this.textInputHigherBound.value = event.target.value;
      this.textInputHigherBound.dispatchEvent(new Event("change", { bubbles: true }));
    });

    this.rangeLowerBound.addEventListener("input", (event) => {
      this.dispatchEvent(new CustomEvent("collection:abort-loading", { bubbles: true }));
      event.target.value = Math.min(parseInt(event.target.value), parseInt(this.textInputHigherBound.value || event.target.max) - 1);
      this.textInputLowerBound.value = event.target.value;
      this.updateRangeStyles();
    });

    this.rangeHigherBound.addEventListener("input", (event) => {
      this.dispatchEvent(new CustomEvent("collection:abort-loading", { bubbles: true }));
      event.target.value = Math.max(parseInt(event.target.value), parseInt(this.textInputLowerBound.value || event.target.min) + 1);
      this.textInputHigherBound.value = event.target.value;
      this.updateRangeStyles();
    });
  }

  updateRangeStyles() {
    this.rangeLowerBound.parentElement.style.setProperty("--range-min", `${(parseInt(this.rangeLowerBound.value) / parseInt(this.rangeLowerBound.max)) * 100}%`);
    this.rangeHigherBound.parentElement.style.setProperty("--range-max", `${(parseInt(this.rangeHigherBound.value) / parseInt(this.rangeHigherBound.max)) * 100}%`);
  }
}

//window.customElements.define("price-range1", PriceRange1);


  //PDP Review Scroll
  window.addEventListener('DOMContentLoaded', (event) => {
    const reviewBtn = document.querySelector('.review_btn');
    const closeBtn = document.querySelector('.close_btn');
    const popupContainer = document.querySelector('.popup_container');
  
    if (reviewBtn) {
      reviewBtn.addEventListener('click', function() {
        if (popupContainer) {
          popupContainer.classList.toggle('hidden');
        } 
      });
    }
    if (closeBtn) {
      closeBtn.addEventListener('click', function() {
        if (popupContainer) {
          popupContainer.classList.add('hidden');
        } 
      });
    } 
  });

//code for bull change filter
jQuery(document).ready(function ($) {
    // Get active
    var getUrlParameter = function getUrlParameter(sParam) {
      var sPageURL = window.location.search.substring(1),
          sURLVariables = sPageURL.split('&'),
          sParameterName,
          i;
  
      for (i = 0; i < sURLVariables.length; i++) {
          sParameterName = sURLVariables[i].split('=');
  
          if (sParameterName[0] === sParam) {
              return sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
          }
      }
      return false;
    };
    if ($('#teilstuck_cut').length) {
      var teilstuck_cut = $('#teilstuck_cut').val();
      teilstuck_cut = $.parseJSON(teilstuck_cut);
      // console.log(teilstuck_cut);
      var filter_custom_cut = getUrlParameter('filter.p.m.custom.cut');
      // console.log(filter_custom_cut);
     
      if(filter_custom_cut && teilstuck_cut){
         $.each(teilstuck_cut, function(key, value) {
          if(value.teilstuck_cut_id == filter_custom_cut){
            var path_id_arr = value.path_id.split('|');
             $.each(path_id_arr, function(key, value) {
               $("#"+value).css({ fill: '#BCB7AC' });
             });
            
            // var extra_title = "";
            // extra_title = value.extra_title;
            // console.log(extra_title);
            $(".value-herkunft").text(value.title);
            // if (typeof value.extra_title != "undefined"){
            //   $(".value-herkunft").html(value.extra_title);
            // }else{
            //   $(".value-herkunft").text(value.title);
            // }
          }
        });
      }
    }
  
    $( ".cls-2,.cls-1" ).click(function(){
        $(".cls-2").css({ fill: '#121212' });
        $(".cls-1").css({ fill: '#121212' });
        var path_id = $(this).attr('id');
       // $(".path_id input").val(path_id);
        $("#"+path_id).css({ fill: '#BCB7AC' });
      var teilstuck_cut = $('#teilstuck_cut').val();
       // alert(path_id);
      teilstuck_cut = $.parseJSON(teilstuck_cut);
      var teilstuck_cut_id = "";
      var teilstuck_cut_ids = "";
      $.each(teilstuck_cut, function(key, value) {
        if(value.path_id){
          var path_id_arr = value.path_id.split('|');
          if(jQuery.inArray(path_id, path_id_arr) !== -1){
          //if(value.path_id == path_id){
            teilstuck_cut_id = value.teilstuck_cut_id;
            $(".value-herkunft").text(value.title);
            if(value.teilstuck_cut_ids){
              teilstuck_cut_ids = value.teilstuck_cut_ids;
            }
          }
        }
      });
      var url_reload = "";
       var urlParams = location.protocol + '//' + location.host + location.pathname
      if(teilstuck_cut_id != ""){
        url_reload = urlParams+'?filter.p.m.custom.cut='+teilstuck_cut_id;
      }
      if(teilstuck_cut_ids != ""){
          url_reload = urlParams;
          $.each(teilstuck_cut_ids, function(key, value) {
            // console.log(value);
            if(key == 0){
              url_reload =  url_reload + '?filter.p.m.custom.cut='+value;
            }
            else{
              url_reload =  url_reload + '&filter.p.m.custom.cut='+value;
            }
          });
        }
      if(url_reload != ""){
        window.location = url_reload;
      }
      
      
    });
    // $( ".cls-1" ).click(function(){
    //     $(".cls-1").css({ fill: '#121212' });
    //     $(".cls-2").css({ fill: '#121212' });
    //     var path_id = $(this).attr('id');
    //     alert(path_id); 
    //   // $(".path_id input").val(path_id);
    //     $("#"+path_id).css({ fill: '#BCB7AC' });

    // });
});





const params = new URLSearchParams(window.location.search);
if (params.get('open_cart') === '1') {
   const cartToggle = document.querySelector('#cart-icon-bubble');
    if (cartToggle) {
      cartToggle.click();
  }
  params.delete('open_cart');
  history.replaceState({}, '', `${location.pathname}?${params}`);
}
